var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCertified(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 2532"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 5",
    cx: 9.5,
    cy: 10,
    r: 9,
    stroke: "#28D781"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 6",
    d: "M4.5 9.5L8 13.5L14 7",
    stroke: "#28D781"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCertified);
export default __webpack_public_path__ + "static/media/certified.bbad80886112481f1f18f7cd9ff32e04.svg";
export { ForwardRef as ReactComponent };